import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { DrawerService } from '../drawer.service';
import { McIcon } from 'makeclub-ui';
import { RouterLink } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'mc-topbar',
  template: `
    <header class="bg-black p-4 pt-[calc(1rem+env(safe-area-inset-top))] text-white shadow-xl">
      <div class="flex items-center gap-4">
        <button
          class="text-3xl text-white md:hidden"
          (click)="drawer.toggle()"
          [attr.aria-label]="'nav.openMenu' | transloco"
        >
          <mc-icon name="menu-2" />
        </button>
        <a routerLink="/app">
          <img class="h-8" src="main-logo.svg" alt="MakeClub" />
        </a>
      </div>
    </header>
  `,
  imports: [RouterLink, McIcon, TranslocoModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopBar {
  protected drawer = inject(DrawerService);
}
